import "./preloader.sass"
import { useLocation } from "react-router-dom"

export function Preloader() {
  const location = useLocation()
  const isIframe = location?.state?.isIframe

  return (
    <div className={`preloader preloader--${isIframe}`} role="status" aria-busy="true">
      <span className="preloader__spinner" />
    </div>
  )
}
